(function() {
    'use strict';

    angular
    .module('valueconnectApp')
    .controller('AppraisalNoteMessageboardController', AppraisalNoteMessageboardController);

    AppraisalNoteMessageboardController.$inject = ['$scope', 'Principal', '$state', 'order', 'messages', 'notes', '$mdDialog', 'report', 'account', 'reportEditable', 'reportSubmittable', 'AppraisalNote', 'AlertService', '$timeout', 'ReportBuilderNav'];

    function AppraisalNoteMessageboardController ($scope, Principal, $state, order, messages, notes, $mdDialog, report, account, reportEditable, reportSubmittable, AppraisalNote, AlertService, $timeout, ReportBuilderNav) {

        var vm = this;

        // Entities
        vm.order = order;
        vm.messages = messages;
        vm.notes = notes;
        vm.account = account;
        vm.report = report;
        vm.onSendNote = onSendNote;
        vm.submitOnEnter = submitOnEnter;

        vm.appraisalMessage = {
            note: null,
            appraisalId: vm.order.id,
            user: { login: '' },
            parent: vm.messages.length > 0 ? { id: vm.messages[vm.messages.length - 1].id } : null,
            isMessage: true
        };

        vm.orderAddress = [vm.order.address.address1, vm.order.address.cityName, vm.order.address.provinceName].filter(Boolean).join(', ');

        // Flags
        vm.reportEditable = reportEditable;
        vm.reportSubmittable = reportSubmittable;
        vm.isCosigner = vm.account.appraiserUser && vm.report.cosignerId === vm.account.appraiserUser.id;

        // Where Build Appraisal Report goes — the rule is shared with the report header.
        var destination = ReportBuilderNav.destination(vm.order, vm.report);
        vm.isValiqueBuilt = destination === 'VALIQUE';
        vm.hasBuilderReport = destination === 'BUILDER';
        vm.openingValique = false;
        vm.openInValique = openInValique;

        // Methods
        vm.createNote = createNote;

        function openInValique(event) {
            if (event) {
                event.preventDefault();
            }
            if (vm.openingValique) {
                return;
            }
            vm.openingValique = true;
            ReportBuilderNav.openInValique(vm.report.id).catch(function() {
                vm.openingValique = false;
            });
        }

        function onSendNote() {
            AppraisalNote.save(vm.appraisalMessage, function() {
                AppraisalNote.getMessagesForAppraisal({id: vm.order.id}, function(result) {
                    vm.messages = result;
                    vm.appraisalMessage.note = null;
                    $timeout(scrollToBottomOfMessages, 0);
                    AlertService.success('Message sent successfully.');
                });
            }, function() {
                AlertService.error('Failed to send message. Contact support if issue persists.');
            });
        }

        // The Textarea will submit the message when the user presses Enter, but not when Shift+Enter is pressed.
        function submitOnEnter(event) {
            if (event.keyCode === 13 && !event.shiftKey) {
                event.preventDefault();
                onSendNote();
            }
        }

        $timeout(scrollToBottomOfMessages, 0);
        function scrollToBottomOfMessages() {
            var messagesContainer = document.querySelector('.messages-container');
            if (messagesContainer) {
                messagesContainer.scrollTop = messagesContainer.scrollHeight;
            }
        }

        function createNote(isMessage, replyId) {
            $mdDialog.show({
                templateUrl: 'app/entities/appraisal-note/appraisal-note-dialog.html',
                controller: 'AppraisalNoteDialogController',
                controllerAs: 'vm',
                clickOutsideToClose: true,
                resolve: {
                    entity: function () {
                        return {
                            note: null,
                            appraisalId: vm.order.id,
                            user: isMessage ? { login: '' } : null,
                            parent: replyId ? { id: replyId } : null,
                            isMessage: isMessage
                        };
                    }
                }
            })
            .then(
                function(data) {
                    $state.go('appraisal-note-messageboard', null, { reload: true });
                }, function() {
                    $state.go('appraisal-note-messageboard');
                }
            );
        }

    }
})();
